export const returnOptions = [
  {
    label: '跳转商店返回按照原版继续试玩',
    value: 'return-normal'
  },
  {
    label: '跳转商店返回可以继续试玩，点击释放状态会再次跳转',
    value: 'return-releaseup'
  },
  {
    label: '跳转商店返回可以继续试玩，点击按下状态会再次跳转',
    value: 'return-touchdown'
  },
  {
    label: '跳转商店返回后不可玩，直达成功状态结算页',
    value: 'return-end-1'
  },
  {
    label: '跳转商店返回后不可玩，直达失败状态结算页',
    value: 'return-end-2'
  }
]
